import axios from 'axios';
import params from 'configs/params';

const apiUrl = params.apiUrl;
const xFunctionsKey = params.xFunctionsKey;
const ocpApimSubscriptionKey = params.ocpApimSubscriptionKey;

export function attemptGetReceipt(data) {
  return axios.request({
    url: `${apiUrl}/receipts?receiptID=${data}`,
    method: 'GET',
    withCredentials: false,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-functions-key': xFunctionsKey,
      'Ocp-Apim-Subscription-Key': ocpApimSubscriptionKey,
    },
  });
}

export function attemptUpdateReceipt(data) {
  return axios.request({
    url: `${apiUrl}/update-receipt`,
    method: 'PATCH',
    withCredentials: false,
    data,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-functions-key': xFunctionsKey,
      'Ocp-Apim-Subscription-Key': ocpApimSubscriptionKey,
    },
  });
}

export function attemptSearchReceipt(data) {
  return axios.request({
    url: `${apiUrl}/search-receipt`,
    method: 'POST',
    withCredentials: false,
    data,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-functions-key': xFunctionsKey,
      'Ocp-Apim-Subscription-Key': ocpApimSubscriptionKey,
    },
  });
}
